module.exports = __webpack_public_path__ + "static/img/23.e99ab53b.png";